import { initialState as initialStateCombiOpdrachten } from '../../../../opdrachten/combi/services/searchCombiOpdrachten'
import { initialState as initialStateProjecten } from '../../../projecten/services/searchProjecten'
import type { FetchKpiFilters } from '../../types/FetchKpi'
import type { Kpi } from '../../types/Kpi'

export {
  generateCombiOpdrachtenQuery,
  generateProjectenQuery,
  isProcesstap,
  isKpi,
  isOpdrachtKpi,
}

const isProcesstap = (kpi: Kpi) => !kpi.code
const isKpi = (kpi: Kpi) => !!kpi.code || kpi.statusText === 'Intake'
const isOpdrachtKpi = (kpi: Kpi) => !!kpi.code

const generateCombiOpdrachtenQuery = ({
  filters,
  kpi,
  kpiColor,
}: {
  filters: FetchKpiFilters
  kpi: Kpi
  kpiColor?: string
}) => {
  const { gebied, netbeheerder, labels, myList } = filters

  const query = {
    filters: {
      ...initialStateCombiOpdrachten.query.filters,
      gebied,
      netbeheerder,
      labels,
      werkbak: { code: kpi.code, label: kpi.statusText },
      myList,
    },
    page: initialStateCombiOpdrachten.query.page,
    sort: initialStateCombiOpdrachten.query.sort,
  }

  if (kpiColor) {
    query.filters.kpi = kpiColor
  }

  return { query, url: '/combiopdrachten' }
}

const generateProjectenQuery = ({
  filters,
  kpi,
  kpiColor,
}: {
  filters: FetchKpiFilters
  kpi: Kpi
  kpiColor?: string
}) => {
  const { gebied, netbeheerder, labels, myList } = filters
  const query = {
    filters: {
      ...initialStateProjecten.query.filters,
      netbeheerder,
      gebied,
      labels,
      myList,
      processtap: [kpi.statusText],
    },
    page: initialStateProjecten.query.page,
    sort: initialStateProjecten.query.sort,
  }

  if (kpiColor) {
    query.filters.kpi = kpiColor
  }

  return { query, url: '/aansluiting/projecten' }
}
